/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Toolbar,
  Typography,
  CardContent, MenuItem, Tooltip
} from "@material-ui/core";

import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import Button from "@material-ui/core/Button";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import Select from "react-select";
import BottomBar from "../../../components/BottomBar/BottomBar";
import { DatePicker } from "@material-ui/pickers";
import { IsEmpty } from "../../../utils/helper";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import Dropzone from "react-dropzone";
import { G } from "@react-pdf/renderer";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import IconButton from "@material-ui/core/IconButton";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

class F300DiscountVoucherForm extends React.Component {
  constructor(props) {
    super(props);
    const ckAdminObject = localStorage.getItem("ckAdminUser") || "{}";
    const ckAdminJsonObject = JSON.parse(ckAdminObject) || {};
    const storedToken = ckAdminJsonObject.jwttoken || "";

    this.state = {
      recordId: this.props.match.params.recordId,
      voucherCode: "",
      voucherLabel: "",
      voucherDescription: "",
      //Voucher Amount Type
      //1-> Percentage
      //2-> Amount
      voucherAmountType: "1",
      voucherPercentage: "",
      voucherAmount: "",
      voucherCategoriesList: [],
      selectedVoucherCategoriesList: [],
      selectAllCategoryProducts: false,
      voucherCategoryProductList: [],
      selectedVoucherCategoriesProductList: [],
      isVoucherAvailableForAllUsers: "1",
      minimumVoucherApplicableAmount: "",
      voucherUsageLimit: "",
      userSpecificId: "",
      effectiveVoucherFrom: new Date(),
      effectiveVoucherTo: this.getTomorrowDate(),
      isVoucherReadyToSubmit: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      token: storedToken,
      colourOptions: [
        { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
        { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
        { value: "purple", label: "Purple", color: "#5243AA" },
        { value: "red", label: "Red", color: "#FF5630", isFixed: true },
        { value: "orange", label: "Orange", color: "#FF8B00" },
        { value: "yellow", label: "Yellow", color: "#FFC400" },
        { value: "green", label: "Green", color: "#36B37E" },
        { value: "forest", label: "Forest", color: "#00875A" },
        { value: "slate", label: "Slate", color: "#253858" },
        { value: "silver", label: "Silver", color: "#666666" },
        { value: "ocean1", label: "Ocean1", color: "#00B8D9", isFixed: true },
        { value: "blue1", label: "Blue1", color: "#0052CC", isDisabled: true },
        { value: "purple1", label: "Purple1", color: "#5243AA" },
        { value: "red1", label: "Red1", color: "#FF5630", isFixed: true },
        { value: "orange1", label: "Orange1", color: "#FF8B00" },
        { value: "yellow1", label: "Yellow1", color: "#FFC400" },
        { value: "green1", label: "Green1", color: "#36B37E" },
        { value: "forest1", label: "Forest1", color: "#00875A" },
        { value: "slate1", label: "Slate1", color: "#253858" },
        { value: "silver1", label: "Silver1", color: "#666666" },
      ],
      usersList: [],
      selectedUsersList: [],
      selectStoreWideCategories: false,
      notification: "",
      voucherType: "1",
      files: [],
      filesError: "",
      isFileSelected: false,
      isActive: 0,
      filesBackground: [],
      filesBackgroundError: "",
      isFileBackgroundSelected: false,
      isMainImageUploaded: 0,
      isBackgroundImageUploaded: 0,
      isTabletBannerImageUploaded: 0,
      isPortraitPhoneBannerImageUploaded: 0,
      filesTabletBanner: [],
      isFileTabletBannerSelected: false,
      filesTabletBannerError: "",
      filesPortraitPhoneBanner: [],
      isFilePortraitPhoneBannerSelected: false,
      filesPortraitPhoneBannerError: "",
      isFullBannerImage: false,
      isNotificationNeededToSent: false,
      isLoginMenu: false,
      isReload: true,
      discountSpecificId: "",
      generalPricingDiscountList: [],
      selectedGeneralPricingDiscountList: [],
      selectedRoute: 0,
      routesOption: [],
      selectedRoutePath: 0,
      routesPathOption: [],
      params: [], // list of { key: "", value: "" }
      paramsJSON: {},
    };
  }

  buildParamsJSON = (params) => {
    return params
      .filter((p) => p.key.trim() !== "")
      .reduce((acc, p) => ({
        ...acc,
        [p.key]: p.value.trim() !== "" && !isNaN(p.value) ? Number(p.value) : p.value,
      }), {});
  };

  handleAddParam = () => {
    this.setState((prev) => {
      const params = [...prev.params, { key: "", value: "" }];
      return { params, paramsJSON: this.buildParamsJSON(params) };
    });
  };

  handleRemoveParam = (index) => {
    this.setState((prev) => {
      const params = prev.params.filter((_, i) => i !== index);
      return { params, paramsJSON: this.buildParamsJSON(params) };
    });
  };

  handleParamChange = (index, field, value) => {
    this.setState((prev) => {
      const params = [...prev.params];
      params[index] = { ...params[index], [field]: value };
      return { params, paramsJSON: this.buildParamsJSON(params) };
    });
  };
  getRoutesData = async () => {
    let notificationTypesDataList = [];
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300MobileApplicationRouteView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {


        this.setState({
          routesOption: res.data,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

  };


  getRoutesPathsData = async (selectedRouteId) => {


    const data = new FormData();
    data.append("routeId", selectedRouteId);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300MobileApplicationRoutePathsView`,
      data,
      "authorize"
    );
    console.log(res)
    if (res.isSuccess) {

      if (res.data != null && res.data.length > 0) {

        this.setState({
          routesPathOption: res.data,
        });
      }
    } else {


      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let errMsg = "";

    switch (name) {
      case "files":
        this.setState({
          isFileSelected: value && value.length > 0,
        });
        break;
      case "filesBackground":
        this.setState({
          isFileBackgroundSelected: value && value.length > 0,
        });
        break;
      default:
        break;
    }

    this.setState({
      [name]: value || "",
      [errName]: errMsg,
    });
  };

  getData = async (index) => {

    debugger;
    const data = new FormData();

    data.append("", index);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsDiscountVouchersView?&recordId=${index}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        let vouchersData = res.data[0];

        let dateFrom = vouchersData.effectiveFrom;
        // const arrFrom = dateFrom.split("/");
        // const effectiveFrom = `${arrFrom[2]}-${arrFrom[1]}-${arrFrom[0]}`;

        let dateTo = vouchersData.effectiveTo;
        // let arrTo = dateTo.split("/");
        // const effectiveTo = `${arrTo[2]}-${arrTo[1]}-${arrTo[0]}`;

        this.getVoucherCategoriesProductData(vouchersData.categoryId);
        // Process Main Image
        let filesArray = [];
        let isMainImageUploaded = 0;

        if (vouchersData.ThumbnailFileName) {
          const constructedImageUrl = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${vouchersData.folderPath + "/" + vouchersData.ThumbnailFileName}`;

          // Optimistically set display object
          filesArray = [{
            name: vouchersData.ThumbnailFileName,
            path: vouchersData.folderPath,
            url: constructedImageUrl
          }];
          isMainImageUploaded = 1;

          try {
            const imageResponse = await fetch(constructedImageUrl);
            if (imageResponse.ok) {
              const blob = await imageResponse.blob();
              if (blob && blob.size > 0) {
                const file = new File([blob], vouchersData.ThumbnailFileName, {
                  type: blob.type || 'image/jpeg',
                  lastModified: Date.now()
                });

                file.path = vouchersData.folderPath;
                file.url = constructedImageUrl;
                file.name = vouchersData.ThumbnailFileName;

                filesArray = [file];
              }
            }
          } catch (error) {
            console.error("Error loading main image blob:", error);
          }
        }

        // Process Background Image
        let filesBackgroundArray = [];
        let isBackgroundImageUploaded = 0;

        if (vouchersData.ThumbnailBackgroungFileName) {
          const constructedBgUrl = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${vouchersData.folderPath + "/" + vouchersData.ThumbnailBackgroungFileName}`;

          // Optimistically set display object
          filesBackgroundArray = [{
            name: vouchersData.ThumbnailBackgroungFileName,
            path: vouchersData.folderPath,
            url: constructedBgUrl
          }];
          isBackgroundImageUploaded = 1;

          try {
            const bgResponse = await fetch(constructedBgUrl);
            if (bgResponse.ok) {
              const blob = await bgResponse.blob();
              if (blob && blob.size > 0) {
                const file = new File([blob], vouchersData.ThumbnailBackgroungFileName, {
                  type: blob.type || 'image/jpeg',
                  lastModified: Date.now()
                });

                file.path = vouchersData.folderPath;
                file.url = constructedBgUrl;
                file.name = vouchersData.ThumbnailBackgroungFileName;

                filesBackgroundArray = [file];
              }
            }
          } catch (error) {
            console.error("Error loading background image blob:", error);
          }
        }

        // Process Portrait Phone Banner Image
        let filesPortraitPhoneBannerArray = [];
        let isPortraitPhoneBannerImageUploaded = 0;

        if (vouchersData.PortraitPhoneBannerFileName) {
          const constructedPortraitUrl = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${vouchersData.folderPath + "/" + vouchersData.PortraitPhoneBannerFileName}`;

          // Optimistically set display object
          filesPortraitPhoneBannerArray = [{
            name: vouchersData.PortraitPhoneBannerFileName,
            path: vouchersData.folderPath,
            url: constructedPortraitUrl
          }];
          isPortraitPhoneBannerImageUploaded = 1;

          try {
            const portraitResponse = await fetch(constructedPortraitUrl);
            if (portraitResponse.ok) {
              const blob = await portraitResponse.blob();
              if (blob && blob.size > 0) {
                const file = new File([blob], vouchersData.PortraitPhoneBannerFileName, {
                  type: blob.type || 'image/jpeg',
                  lastModified: Date.now()
                });

                file.path = vouchersData.folderPath;
                file.url = constructedPortraitUrl;
                file.name = vouchersData.PortraitPhoneBannerFileName;

                filesPortraitPhoneBannerArray = [file];
              }
            }
          } catch (error) {
            console.error("Error loading portrait phone banner image blob:", error);
          }
        }

        // Process Tablet Banner Image
        let filesTabletBannerArray = [];
        let isTabletBannerImageUploaded = 0;

        if (vouchersData.TabletBannerFileName) {
          const constructedTabletUrl = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${vouchersData.folderPath + "/" + vouchersData.TabletBannerFileName}`;

          // Optimistically set display object
          filesTabletBannerArray = [{
            name: vouchersData.TabletBannerFileName,
            path: vouchersData.folderPath,
            url: constructedTabletUrl
          }];
          isTabletBannerImageUploaded = 1;

          try {
            const tabletResponse = await fetch(constructedTabletUrl);
            if (tabletResponse.ok) {
              const blob = await tabletResponse.blob();
              if (blob && blob.size > 0) {
                const file = new File([blob], vouchersData.TabletBannerFileName, {
                  type: blob.type || 'image/jpeg',
                  lastModified: Date.now()
                });

                file.path = vouchersData.folderPath;
                file.url = constructedTabletUrl;
                file.name = vouchersData.TabletBannerFileName;

                filesTabletBannerArray = [file];
              }
            }
          } catch (error) {
            console.error("Error loading tablet banner image blob:", error);
          }
        }



        let parsedParams = [];
        let parsedParamsJSON = {};

        if (vouchersData.paramsJSON) {
          try {
            parsedParamsJSON = typeof vouchersData.paramsJSON === "string"
              ? JSON.parse(vouchersData.paramsJSON)
              : vouchersData.paramsJSON;

            parsedParams = Object.entries(parsedParamsJSON).map(([key, value]) => ({
              key,
              value: String(value),
            }));
          } catch (e) {
            console.error("Failed to parse paramsJSON:", e);
          }
        }

        console.log("About to setState with:", {
          voucherCode: vouchersData.voucherCode,
          voucherLabel: vouchersData.voucherLabel,
          voucherDescription: vouchersData.description,
          selectedUsersList: vouchersData.userId,
          categoryId: vouchersData.categoryId,
        });


        try {
          this.setState({
            Data: res.data || [],
            isVoucherAvailableForAllUsers: vouchersData.isAvaliableForAll,
            voucherCode: vouchersData.voucherCode,
            voucherLabel: vouchersData.voucherLabel,
            voucherDescription: vouchersData.description,
            voucherAmountType: vouchersData.isPercentage,

            voucherPercentage: vouchersData.percentage,
            voucherAmount: vouchersData.amount,
            selectedVoucherCategoriesProductList: vouchersData.isSelectedAll
              ? []
              : vouchersData.productId,

            selectAllCategoryProducts: vouchersData.isSelectedAll,
            minimumVoucherApplicableAmount: vouchersData.minAmountCap,
            voucherUsageLimit: vouchersData.usageLimitCount,
            effectiveVoucherFrom: dateFrom,
            effectiveVoucherTo: dateTo,
            selectedUsersList: vouchersData.userId,
            selectedVoucherCategoriesList: vouchersData.categoryId,
            selectStoreWideCategories: vouchersData.isStoreWide,
            isFullBannerImage: vouchersData.isFullBannerImage,
            isNotificationNeededToSent: vouchersData.isNotificationNeededToSent,
            discountSpecificId: vouchersData.selectedGeneralPricingDiscountList &&
              vouchersData.selectedGeneralPricingDiscountList.length > 0
              ? vouchersData.selectedGeneralPricingDiscountList[0].id
              : "",

            selectedGeneralPricingDiscountList: vouchersData.selectedGeneralPricingDiscountList &&
              vouchersData.selectedGeneralPricingDiscountList.length > 0
              ? vouchersData.selectedGeneralPricingDiscountList
              : [],
            notification: vouchersData.notificationMsg,
            files: filesArray,
            isMainImageUploaded: isMainImageUploaded,
            isFileSelected: filesArray.length > 0,
            filesBackground: filesBackgroundArray,
            isBackgroundImageUploaded: isBackgroundImageUploaded,
            isFileBackgroundSelected: filesBackgroundArray.length > 0,
            filesPortraitPhoneBanner: filesPortraitPhoneBannerArray,
            isPortraitPhoneBannerImageUploaded: isPortraitPhoneBannerImageUploaded,
            isFilePortraitPhoneBannerSelected: filesPortraitPhoneBannerArray.length > 0,
            filesTabletBanner: filesTabletBannerArray,
            isTabletBannerImageUploaded: isTabletBannerImageUploaded,
            isFileTabletBannerSelected: filesTabletBannerArray.length > 0,
            voucherType: vouchersData.voucherType,
            // Route/Navigation fields
            selectedRoute: vouchersData.pageRouteId || 0,
            selectedRoutePath: vouchersData.pageRoutePathId || 0,

            params: parsedParams,
            paramsJSON: parsedParamsJSON,

            //isFullBannerImage: vouchersData.voucherType == "2" || vouchersData.isFullBannerImage == 1,
          });
          console.log("setState completed successfully");
        } catch (err) {
          console.error("setState failed:", err);
        }

        // Load route path options
        if (vouchersData.pageRouteId) {
          this.getRoutesPathsData(vouchersData.pageRouteId);
        }
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    // this.setState({
    //     isLoading: false,
    // });
  };
  getTomorrowDate = () => {
    let a = new Date();
    a.setDate(a.getDate() + 1);
    return a;
  };

  componentDidMount = async () => {


    // Load all dropdown data first and wait for them to complete
    await Promise.all([
      this.getVoucherCategoriesData(),
      this.getUsersData(),
      this.getGeneralDiscountPricingData(),
      this.getRoutesData()
    ]);

    const id = this.props.match.params.recordId;
    if (id != 0) {
      this.setState({
        recordId: id,
      });
      this.getData(id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match.params.recordId != nextProps.match.params.recordId) {
      if (nextProps.match.params.recordId != 0) {
        this.getData(nextProps.match.params.recordId);
      } else {
        window.location.reload();
      }
    }
  }

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  setVoucherAmountType = async (e) => {
    await this.setState({
      voucherAmountType: e.target.value,
    });
    this.validateVoucherForm();
  };

  setVoucherCategoryV2 = async (e) => {
    // //debugger;
    if (this.state.voucherType == "1") {
      // let selectedCategory = ;
      let selectedVoucherCategoriesList = [];
      selectedVoucherCategoriesList.push(e);
      this.setState({
        selectedVoucherCategoriesList: selectedVoucherCategoriesList,
      });

      this.getVoucherCategoriesProductData(selectedVoucherCategoriesList);
    } else {
      this.state.selectedVoucherCategoriesList = [];
      this.setState({
        selectedVoucherCategoriesList: e,
      });
      this.getVoucherCategoriesProductData(e);
    }

    //
  };

  setUsers = async (e) => {
    this.state.userSpecificId = "";
    await this.setState({
      userSpecificId: e.id,
      selectedUsersList: e,
    });
  };



  setGeneralPricingDiscount = async (e) => {
    this.state.discountSpecificId = "";
    await this.setState({
      discountSpecificId: e.id,
      selectedGeneralPricingDiscountList: e,
    });
  };

  getVoucherCategoriesData = async () => {
    let voucherCategoriesDataList = [];
    // e.preventDefault();
    // this.setState({
    //     isLoading: true,
    // });
    // const data = new FormData(e.target);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsCategoriesView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let jsonNode = {
            value: res.data[i].label,
            label: res.data[i].label,
            id: res.data[i].id,
            userLabel: res.data[i].userLabel,
            isFixed: false,
            isDisabled: false,
          };
          voucherCategoriesDataList.push(jsonNode);
        }
        this.setState({
          voucherCategoriesList: voucherCategoriesDataList,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    // this.setState({
    //     isLoading: false,
    // });
  };

  getVoucherCategoriesProductData = async (selectedVoucherCategoriesList) => {
    let voucherCategoryProductDataList = [];
    // e.preventDefault();
    // this.setState({
    //     isLoading: true,
    // });
    // const data = new FormData(e.target);
    if (selectedVoucherCategoriesList.length > 0) {
      const data = new FormData();
      for (let i = 0; i < selectedVoucherCategoriesList.length; i++) {
        data.append("categoryId", selectedVoucherCategoriesList[i].id);
      }
      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsView`,
        data,
        "authorize"
      );
      if (res.isSuccess) {
        if (res.data != null && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            let jsonNode = {
              value: res.data[i].label,
              label: res.data[i].label,
              id: res.data[i].id,
              userLabel: res.data[i].userLabel,
              isFixed: false,
              isDisabled: false,
            };
            voucherCategoryProductDataList.push(jsonNode);
          }
          this.setState({
            voucherCategoryProductList: voucherCategoryProductDataList,
          });
        }
      } else {
        // if (res.statusCode === 401) {
        //     this.setState({
        //         isLoginMenu: true,
        //         isReload: false,
        //     });
        // } else {
        //     this.handleSnackbar(true, res.message, "error");
        // }
      }
    }

    // this.setState({
    //     isLoading: false,
    // });
  };

  getGeneratedVoucherCodeFromServer = async () => {
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsDiscountVouchersGenerateView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        const vCode = res.data[0]["voucherCode"];
        await this.setState({
          voucherCode: vCode,
        });
        this.validateVoucherForm();
      }
    } else {
      // if (res.statusCode === 401) {
      //     this.setState({
      //         isLoginMenu: true,
      //         isReload: false,
      //     });
      // } else {
      //     this.handleSnackbar(true, res.message, "error");
      // }
    }
  };

  getUsersData = async () => {
    let usersList = [];
    // e.preventDefault();
    // this.setState({
    //     isLoading: true,
    // });
    // const data = new FormData(e.target);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonUsersView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let jsonNode = {
            value: res.data[i].id,
            label: res.data[i].id + " - " + res.data[i].displayName,
            id: res.data[i].id,
            userLabel: res.data[i].displayName,
            isFixed: false,
            isDisabled: false,
          };
          usersList.push(jsonNode);
        }
        this.setState({
          usersList: usersList,
        });
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    // this.setState({
    //     isLoading: false,
    // });
  };

  onClickSubmit = () => {
    document.getElementById("F300FromSubmitButton").click();
  };

  submitVoucher = async (e) => {
    //debugger;
    e.preventDefault();
    const data = new FormData(e.target);
    const isVoucherAvailableForAll = this.state.isVoucherAvailableForAllUsers;
    const voucherCode = this.state.voucherCode;
    const voucherLabel = this.state.voucherLabel;
    const voucherDescription = this.state.voucherDescription;
    const pageRoute = this.state.selectedRoute;
    const mobilePageRoute = this.state.selectedRoutePath;

    if (this.state.voucherType !== "2") {
      if (!voucherLabel) {
        this.handleSnackbar(true, "Please enter voucher label.", "error");
        return false;
      }

      if (!voucherDescription) {
        this.handleSnackbar(true, "Please enter voucher description.", "error");
        return false;
      }

      if (!voucherCode) {
        this.handleSnackbar(true, "Please generate voucher code.", "error");
        return false;
      }



      if (this.state.voucherAmountType === "1") {
        if (!this.state.voucherPercentage) {
          this.handleSnackbar(true, "Please enter voucher percentage.", "error");
          return false;
        }
      } else {
        if (!this.state.voucherAmount) {
          this.handleSnackbar(true, "Please enter voucher amount.", "error");
          return false;
        }
      }

      if (this.state.selectStoreWideCategories == "0") {

        if (this.state.selectedVoucherCategoriesList.length > 0) {
          if (!this.state.selectStoreWideCategories) {
            if (
              this.state.selectedVoucherCategoriesProductList.length > 0 ||
              this.state.selectAllCategoryProducts
            ) {
              // Nothing
            } else {
              this.handleSnackbar(true, "Please select products.", "error");
              return false;
            }
          }
        } else {
          this.handleSnackbar(true, "Please select category.", "error");
          return false;
        }
      }

      // if (this.state.selectedVoucherCategoriesList.length > 0) {
      //   if (!this.state.selectStoreWideCategories) {
      //     if (
      //       this.state.selectedVoucherCategoriesProductList.length > 0 ||
      //       this.state.selectAllCategoryProducts
      //     ) {
      //       // Nothing
      //     } else {
      //       this.handleSnackbar(true, "Please select products.", "error");
      //       return false;
      //     }
      //   }
      // } else {
      //   this.handleSnackbar(true, "Please select category.", "error");
      //   return false;
      // }

      if (!this.state.minimumVoucherApplicableAmount) {
        this.handleSnackbar(
          true,
          "Please enter voucher minimum voucher applicable amount.",
          "error"
        );
        return false;
      }

      if (!this.state.voucherUsageLimit) {
        this.handleSnackbar(true, "Please enter voucher usage limit.", "error");
        return false;
      }

      if (this.state.isNotificationNeededToSent) {
        if (!this.state.notification) {
          this.handleSnackbar(
            true,
            "Please enter voucher notification text.",
            "error"
          );
          return false;
        }
      }



      if (this.state.voucherType == "1" && !this.state.isFullBannerImage) {
        if (
          !this.state.isFileSelected ||
          !this.state.files ||
          this.state.files.length === 0
        ) {
          this.handleSnackbar(true, "Please select Main Card Image.", "error");
          return false;
        }
        if (
          !this.state.isFileBackgroundSelected ||
          !this.state.filesBackground ||
          this.state.filesBackground.length === 0
        ) {
          this.handleSnackbar(
            true,
            "Please select Main Card Image Background.",
            "error"
          );
          return false;
        }
      }
    } else {
      //debugger;
      if (!this.state.discountSpecificId) {
        this.handleSnackbar(true, "Please select general discount pricing.", "error");
        return false;
      }
    }

    if (this.state.voucherType == "1" || this.state.voucherType == "2") {
      if (this.state.selectedRoute && this.state.selectedRoute !== "0") {
        if (!this.state.selectedRoutePath || this.state.selectedRoutePath == "0") {
          this.handleSnackbar(true, "Please select mobile app path.", "error");
          return false;
        }

        // If route path is selected, validate params
        if (this.state.selectedRoutePath && this.state.selectedRoutePath !== "0") {
          if (this.state.params.length > 0) {
            for (let i = 0; i < this.state.params.length; i++) {
              const param = this.state.params[i];

              if (!param.key.trim() && !param.value.trim()) {
                this.handleSnackbar(true, `Param row ${i + 1}: Both key and value are empty. Please fill or remove it.`, "error");
                return false;
              }

              if (!param.key.trim()) {
                this.handleSnackbar(true, `Param row ${i + 1}: Key is required.`, "error");
                return false;
              }

              if (!param.value.toString().trim()) {
                this.handleSnackbar(true, `Param row ${i + 1}: Value is required for key "${param.key}".`, "error");
                return false;
              }
            }

            // Check for duplicate keys
            const keys = this.state.params.map((p) => p.key.trim());
            const duplicates = keys.filter((k, i) => keys.indexOf(k) !== i);
            if (duplicates.length > 0) {
              this.handleSnackbar(true, `Duplicate param key found: "${duplicates[0]}". Keys must be unique.`, "error");
              return false;
            }
          }
        }
      }
    }

    //debugger;


    if (this.state.isFullBannerImage) {
      if (
        !this.state.isFilePortraitPhoneBannerSelected ||
        !this.state.filesPortraitPhoneBanner ||
        this.state.filesPortraitPhoneBanner.length === 0
      ) {
        this.handleSnackbar(true, "Please select Portrait Phone Banner.", "error");
        return false;
      }
      if (
        !this.state.isFileTabletBannerSelected ||
        !this.state.filesTabletBanner ||
        this.state.filesTabletBanner.length === 0
      ) {
        this.handleSnackbar(
          true,
          "Please select Tablet Banner.",
          "error"
        );
        return false;
      }
    }



    const voucherAmountType = this.state.voucherAmountType;
    const voucherPercentage = this.state.voucherPercentage;
    const voucherAmount = this.state.voucherAmount;

    const selectedVoucherCategoriesProductList =
      this.state.selectedVoucherCategoriesProductList;
    const selectAllCategoryProducts = this.state.selectAllCategoryProducts;
    const minimumApplicableAmount = this.state.minimumVoucherApplicableAmount;
    const voucherUsageLimit = this.state.voucherUsageLimit;
    let effectiveFrom = "";
    let effectiveTo = "";
    let notification = "";
    if (this.state.voucherType !== "2") {
      effectiveFrom = document.getElementById("effectiveVoucherFrom").value;
      effectiveTo = document.getElementById("effectiveVoucherTo").value;
      notification = this.state.notification;
    }

    const isLimitedOffer = this.state.voucherType;

    let userId = !IsEmpty(this.state.selectedUsersList)
      ? this.state.selectedUsersList.id
      : "";
    const userSpecificId = userId;
    const selectedVoucherCategoriesList =
      this.state.selectedVoucherCategoriesList;
    notification = this.state.notification;
    const isStoreWide = this.state.selectStoreWideCategories;

    data.append("isStoreWide", isStoreWide ? "1" : "0");
    data.append("recordId", this.state.recordId);
    data.append("voucherCode", voucherCode);
    data.append("voucherLabel", voucherLabel);
    data.append("remarksUser", voucherDescription);
    data.append("isPercentage", voucherAmountType);
    data.append("voucherAmount", voucherAmount === "" ? 0 : voucherAmount);
    data.append(
      "voucherPercentage",
      voucherPercentage === "" ? 0 : voucherPercentage
    );
    for (let i = 0; i < selectedVoucherCategoriesList.length; i++) {
      data.append("categoryId", selectedVoucherCategoriesList[i]["id"]);
    }

    if (!selectAllCategoryProducts) {
      for (let i = 0; i < selectedVoucherCategoriesProductList.length; i++) {
        data.append("productId", selectedVoucherCategoriesProductList[i]["id"]);
      }
    } else {
      data.append("isSelectedAll", "1");
    }

    data.append("isAvaliableForAll", isVoucherAvailableForAll);
    if (isVoucherAvailableForAll === "0") {
      data.append("userId", userSpecificId);
    }

    //for (let i = 0; i < this.state.selectedGeneralPricingDiscountList.length; i++) {
    data.append("generalDiscountPricingId", this.state.discountSpecificId);
    //}

    data.append("minAmountCap", minimumApplicableAmount);
    data.append("usageLimitCount", voucherUsageLimit);
    data.append("effectiveFrom", effectiveFrom);
    data.append("effectiveTo", effectiveTo);

    data.append("isFullBannerImage", this.state.isFullBannerImage ? 1 : 0);
    data.append("isNotificationNeededToSent", this.state.isNotificationNeededToSent ? 1 : 0);
    data.append("notificationMsg", notification);
    data.append("isLimitedOffer", isLimitedOffer);
    if (
      isLimitedOffer == "1" &&
      this.state.isFileSelected &&
      this.state.files &&
      this.state.files.length > 0
    ) {
      data.append("file", this.state.files[0]);
    }

    if (
      isLimitedOffer == "1" &&
      this.state.isFileBackgroundSelected &&
      this.state.filesBackground &&
      this.state.filesBackground.length > 0
    ) {
      data.append("fileBackground", this.state.filesBackground[0]);
    }

    if (
      this.state.isFullBannerImage &&
      this.state.isFilePortraitPhoneBannerSelected &&
      this.state.filesPortraitPhoneBanner &&
      this.state.filesPortraitPhoneBanner.length > 0
    ) {
      data.append("filePortraitPhoneBanner", this.state.filesPortraitPhoneBanner[0]);
    }

    if (
      this.state.isFullBannerImage &&
      this.state.isFileTabletBannerSelected &&
      this.state.filesTabletBanner &&
      this.state.filesTabletBanner.length > 0
    ) {
      data.append("fileTabletBanner", this.state.filesTabletBanner[0]);
    }

    data.append("pageRouteId", pageRoute);
    data.append("pagePathRouteId", mobilePageRoute);
    data.append("paramsJSON", JSON.stringify(this.state.paramsJSON));

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsDiscountVouchersSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      window.location.reload();
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
  };

  viewReport = async () => {
    window.location = "#/F300DiscountVoucherReport";
  };

  setVoucherCategoryProductV2 = async (e) => {
    this.state.selectedVoucherCategoriesProductList = [];
    await this.setState({
      selectedVoucherCategoriesProductList: e,
    });
    this.validateVoucherForm();
  };

  updateAllCategoryProductsSelection = async (e) => {
    await this.setState({
      selectAllCategoryProducts: e.target.checked,
      selectedVoucherCategoriesProductList: [],
    });
    this.validateVoucherForm();
  };

  updateStoreWideCategoriesSelection = async (e) => {
    await this.setState({
      selectStoreWideCategories: e.target.checked,
    });
    //this.validateVoucherForm();
  };


  isNotificationNeededToSent = async (e) => {
    await this.setState({
      isNotificationNeededToSent: e.target.checked,
    });
  };

  setVoucherType = async (e) => {

    let isFullBannerImage = false;
    if (e.target.value == "2") {
      isFullBannerImage = true;
    } else {
      isFullBannerImage = false;
    }


    if (e.target.value == "1" || e.target.value == "2") {
      await this.setState({
        voucherType: e.target.value,
        isFullBannerImage: isFullBannerImage,
        params: {},
        paramsJSON: "{}",
        selectedRoute: 0,
        selectedRoutePath: 0,

      });
    } else {
      await this.setState({
        voucherType: e.target.value,
        isFullBannerImage: isFullBannerImage,
      });
    }

  };

  setVoucherAvailableForAll = async (e) => {
    await this.setState({
      isVoucherAvailableForAllUsers: e.target.value,
    });
    this.validateVoucherForm();
  };

  setEffectiveFrom = (date) => {
    // let date = e.target.value;
    // const arr = date.split("-");
    // const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    this.setState({
      effectiveVoucherFrom: date,
    });
    // this.validateVoucherForm();
  };

  setEffectiveTo = (date) => {
    // let date = e.target.value;
    // const arr = date.split("-");
    // const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    this.setState({
      effectiveVoucherTo: date,
    });
    // this.validateVoucherForm();
  };

  validateVoucherForm() {
    //Validate All Users or UserSpecific

    let isAllFieldsValidated;
    if (this.state.isVoucherAvailableForAllUsers === "1") {
      isAllFieldsValidated = true;
    } else {
      if (this.state.userSpecificId) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    }

    if (this.state.voucherLabel) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.voucherDescription) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.voucherCode) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }
    if (this.state.voucherAmountType === "1") {
      if (this.state.voucherPercentage) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    } else {
      if (this.state.voucherAmount) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    }

    if (this.state.selectedVoucherCategoriesList.length > 0) {
      isAllFieldsValidated = true;
      if (
        this.state.selectedVoucherCategoriesProductList.length > 0 ||
        this.state.selectAllCategoryProducts
      ) {
        isAllFieldsValidated = true;
      } else {
        isAllFieldsValidated = false;
        this.setState({
          isVoucherReadyToSubmit: isAllFieldsValidated,
        });
        return isAllFieldsValidated;
      }
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.minimumVoucherApplicableAmount) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.voucherUsageLimit) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.effectiveVoucherFrom) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.effectiveVoucherTo) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (this.state.notification) {
      isAllFieldsValidated = true;
    } else {
      isAllFieldsValidated = false;
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
      return isAllFieldsValidated;
    }

    if (isAllFieldsValidated) {
      this.setState({
        isVoucherReadyToSubmit: isAllFieldsValidated,
      });
    }
  }

  onDrop = (files) => {
    if (files.length > 0) {
      this.setState({
        files,
        isFileSelected: true,
        isMainImageUploaded: 1,
        filesError: "",
      });
    } else {
      this.setState({
        isFileSelected: false,
        isMainImageUploaded: 0,
      });
    }
  };

  onDropBackground = (files) => {
    if (files.length > 0) {
      this.setState({
        filesBackground: files,
        isFileBackgroundSelected: true,
        isBackgroundImageUploaded: 1,
        filesBackgroundError: "",
      });
    } else {
      this.setState({
        isFileBackgroundSelected: false,
        isBackgroundImageUploaded: 0,
      });
    }
  };



  onDrop = (files) => {
    if (files.length > 0) {
      this.setState({
        files,
        isFileSelected: true,
        isMainImageUploaded: 1,
        filesError: "",
      });
    } else {
      this.setState({
        isFileSelected: false,
        isMainImageUploaded: 0,
      });
    }
  };

  onDropBackground = (files) => {
    if (files.length > 0) {
      this.setState({
        filesBackground: files,
        isFileBackgroundSelected: true,
        isBackgroundImageUploaded: 1,
        filesBackgroundError: "",
      });
    } else {
      this.setState({
        isFileBackgroundSelected: false,
        isBackgroundImageUploaded: 0,
      });
    }
  };



  onDropTabletBanner = (files) => {
    if (files.length > 0) {
      this.setState({
        filesTabletBanner: files,
        isFileTabletBannerSelected: true,
        isTabletBannerImageUploaded: 1,
        filesTabletBannerError: "",
      });
    } else {
      this.setState({
        isFileTabletBannerSelected: false,
        isTabletBannerImageUploaded: 0,
      });
    }
  };

  onDropPortraitPhoneBanner = (files) => {
    if (files.length > 0) {
      this.setState({
        filesPortraitPhoneBanner: files,
        isFilePortraitPhoneBannerSelected: true,
        isPortraitPhoneBannerImageUploaded: 1,
        filesPortraitPhoneBannerError: "",
      });
    } else {
      this.setState({
        isFilePortraitPhoneBannerSelected: false,
        isPortraitPhoneBannerImageUploaded: 0,
      });
    }
  };


  handleRouteChange = (event) => {
    this.setState({ selectedRoute: event.target.value });

    this.getRoutesPathsData(event.target.value);

  };

  handleRoutePathChange = (event) => {
    this.setState({ selectedRoutePath: event.target.value });
  };

  getGeneralDiscountPricingData = async () => {
    let generalPricingDiscountList = [];
    this.setState({
      isLoading: true,
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonProductsGeneralDiscountPricingView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.isSuccess) {
        if (res.data != null && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            let jsonNode = {
              value: res.data[i].id,
              label: res.data[i].isActive == 1 ? res.data[i].id + " - " + res.data[i].discountLabel + " (Active)" : res.data[i].id + " - " + res.data[i].discountLabel,
              id: res.data[i].id,
              userLabel: res.data[i].discountLabel,
              isFixed: false,
              isDisabled: res.data[i].statusId === 3 ? true : false,
              statusId: res.data[i].statusId,
              //isDisabled: false,

            };
            generalPricingDiscountList.push(jsonNode);
          }
          this.setState({
            generalPricingDiscountList: generalPricingDiscountList,
          });
        }
      } else {
        if (res.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
          });
        } else {
          this.handleSnackbar(true, res.message, "error");
        }
      }


      this.setState({
        isLoading: false,
      });
    };
  }


  render() {
    const { voucherAmountType } = this.state;
    let { usersList } = this.state;
    let { voucherCategoriesList } = this.state;
    let { selectedVoucherCategoriesList } = this.state;
    let { voucherCategoryProductList } = this.state;
    let { selectStoreWideCategories } = this.state;
    let { selectAllCategoryProducts } = this.state;
    let { isVoucherAvailableForAllUsers } = this.state;
    let { voucherType } = this.state;
    let { voucherCode } = this.state;
    let { selectedVoucherCategoriesProductList } = this.state;
    let { generalPricingDiscountList } = this.state;
    let { isFullBannerImage } = this.state;
    let { isNotificationNeededToSent } = this.state;
    let { selectedRoute } = this.state;
    let { routesOption } = this.state;
    let { selectedRoutePath } = this.state;
    let { routesPathOption } = this.state;

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <Grid
          container
          xs={12}
          direction={"column"}
          justifyContent="center"
          alignItems="center"
          style={{ padding: 10 }}
        >
          <Toolbar>
            <NavBar isAuthorize title="Discount Voucher Dashboard" />
            {/* <LoginMenu 
                    reload={this.state.isReload}
                    open={this.state.isLoginMenu}
                    handleClose={() => this.setState({ isLoginMenu: false })}
                    /> */}
          </Toolbar>
          <Card
            style={{
              width: "98%",
              // height: "auto",
              // minHeight: "100vh",
              // paddingTop: 20,
              paddingBottom: 100,
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            <TextField type="hidden" name="id" value={this.state.recordId} />
            <FormLabel component="legend">Select discount type : </FormLabel>

            <div style={{ width: "100%", marginBottom: 10 }}>
              <RadioGroup
                row
                aria-label="voucher-type"
                name="voucher-type"
                defaultValue={"0"}
                value={voucherType + ""}
                onChange={(e) => this.setVoucherType(e)}
              >

                <FormControlLabel
                  value="1"
                  control={<Radio style={{ color: "#3f51b5" }} />}
                  label="Limited Time Offer"
                />
                <FormControlLabel
                  value="0"
                  control={<Radio style={{ color: "#3f51b5" }} />}
                  label="Discount Voucher"
                />

                <FormControlLabel
                  value="2"
                  control={<Radio style={{ color: "#3f51b5" }} />}
                  label="General Pricing Discount Offer"
                />
              </RadioGroup>

              {(this.state.voucherType + "" === "1" || this.state.voucherType + "" === "2") && (
                <>
                  {/* Route + RoutePath row */}
                  <div style={{ width: "100%", display: "flex", justifyContent: "left", marginTop: "20px", marginBottom: "20px" }}>
                    <Grid container item xs={6}>
                      <TextField
                        value={selectedRoute}
                        onChange={this.handleRouteChange}
                        label="Page Route"
                        select fullWidth variant="outlined" size="small"
                      >
                        {routesOption.map((option) => (
                          <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <div style={{ width: "1%" }} />

                    <Grid container item xs={6}>
                      <TextField
                        value={selectedRoutePath}
                        onChange={this.handleRoutePathChange}
                        label="Mobile App Path"
                        select fullWidth variant="outlined" size="small"
                      >
                        {routesPathOption.map((option) => (
                          <MenuItem key={option.id} value={option.id}>{option.urlPath}</MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </div>

                  {/* Params section — only shown when a route path is selected */}
                  {(selectedRoutePath && this.state.voucherType === "1") && (
                    <>
                      {/* Param rows */}

                      {this.state.params.length > 0 && this.state.params.map((param, index) => (
                        <div
                          key={index}
                          style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "12px", gap: "1%" }}
                        >
                          <TextField
                            label="Param Key"
                            variant="outlined"
                            size="small"
                            value={param.key}
                            onChange={(e) => this.handleParamChange(index, "key", e.target.value)}
                            style={{ width: "49.5%" }}
                          />
                          <TextField
                            label="Param Value"
                            variant="outlined"
                            size="small"
                            value={param.value}
                            inputProps={{ maxLength: 250 }}
                            onChange={(e) => this.handleParamChange(index, "value", e.target.value)}
                            style={{ width: "49.5%" }}
                          />
                          {/* Remove button */}
                          <IconButton
                            size="small"
                            onClick={() => this.handleRemoveParam(index)}
                            style={{ color: "#f44336" }}
                          >
                            <RemoveCircleOutlineIcon fontSize="small" />
                          </IconButton>
                        </div>
                      ))}

                      {/* Add button */}
                      <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "20px" }}>
                        <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          startIcon={<AddCircleOutlineIcon />}
                          onClick={this.handleAddParam}
                        >
                          Add Param
                        </Button>
                      </div>
                      {/* JSON Preview */}
                      {this.state.params.length > 0 && (
                        <div style={{ width: "100%", marginBottom: "20px" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                            <span style={{ fontSize: "12px", color: "#757575", fontWeight: 600 }}>
                              JSON Preview
                            </span>
                            <Tooltip title="Copy JSON">
                              <IconButton
                                size="small"
                                onClick={() => navigator.clipboard.writeText(JSON.stringify(this.state.paramsJSON, null, 2))}
                              >
                                <FileCopyOutlinedIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </div>

                          <pre style={{ backgroundColor: "#f5f5f5", border: "1px solid #e0e0e0", borderRadius: "6px", padding: "12px 16px", fontSize: "13px", fontFamily: "monospace", whiteSpace: "pre-wrap", wordBreak: "break-all", margin: 0, color: "#212121" }}>
                            {JSON.stringify(this.state.paramsJSON, null, 2)}
                          </pre>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              {this.state.voucherType + "" == "1" && (
                <>




                  <div style={{ width: "100%" }}>

                    <>
                      <span style={{}}>
                        {
                          <FormControl component="fieldset">
                            <FormLabel component="legend">
                              Tick mark the checkbox for Full Banner Image{" "}
                            </FormLabel>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={
                                      this.state.voucherType + "" == "1"
                                        ? false
                                        : true
                                    }
                                    checked={isFullBannerImage}
                                    onChange={(e) =>
                                      this.setState({
                                        isFullBannerImage: e.target.checked,
                                      })
                                    }
                                    name="full-banner-image"
                                    style={{ color: "#3f51b5" }}
                                  />
                                }
                                label="Full Banner Image"
                              />
                            </FormGroup>
                          </FormControl>
                        }
                      </span>
                    </>
                  </div>


                </>

              )}




              {isFullBannerImage ?
                <>
                  {/* Portrait Image Section */}
                  <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <Typography variant="subtitle2" style={{ marginBottom: 10, fontWeight: 600 }}>
                      Portrait Phone Banner Image*
                    </Typography>

                    {this.state.isPortraitPhoneBannerImageUploaded === 0 && (
                      <Dropzone
                        accept={"image/png, image/jpeg, image/jpg, image/gif"}
                        onDrop={this.onDropPortraitPhoneBanner}
                        multiple={false}
                        maxSize={5242880} // 5MB limit
                      >
                        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                          <section>
                            <div
                              style={{ textAlign: "center" }}
                              {...getRootProps({
                                className: "dropzone",
                                onChange: (event) =>
                                  this.handleChange({
                                    target: {
                                      name: "filesPortraitPhoneBanner",
                                      value: event.target.files || [],
                                    },
                                  }),
                              })}
                            >
                              <Card
                                style={{
                                  backgroundColor: isDragActive
                                    ? "#e3f2fd"
                                    : isDragReject
                                      ? "#ffebee"
                                      : "#f5f5f5",
                                  marginTop: 10,
                                  border: isDragActive
                                    ? "2px dashed #2196f3"
                                    : isDragReject
                                      ? "2px dashed #f44336"
                                      : "2px dashed #ccc",
                                  transition: "all 0.3s ease",
                                  cursor: "pointer",
                                }}
                              >
                                <CardContent
                                  style={{
                                    paddingBottom: 18,
                                    padding: 30,
                                  }}
                                >
                                  <input name="filePortraitPhoneBanner" {...getInputProps()} />
                                  <div style={{ marginBottom: 10 }}>
                                    <i
                                      className="fas fa-cloud-upload-alt"
                                      style={{ fontSize: 48, color: "#999" }}
                                    />
                                  </div>
                                  <Typography
                                    style={{ cursor: "pointer" }}
                                    variant="subtitle1"
                                    color={this.state.filesPortraitPhoneBanner.length > 0 ? "primary" : "textSecondary"}
                                  >
                                    {this.state.filesPortraitPhoneBanner.length > 0
                                      ? `Selected: ${this.state.filesPortraitPhoneBanner[0].name || this.state.filesPortraitPhoneBanner[0].path}`
                                      : isDragActive
                                        ? "Drop the image here..."
                                        : "Click to select an image or drag and drop"}
                                  </Typography>
                                  <Typography variant="caption" display="block" style={{ marginTop: 5 }}>
                                    Supported formats: PNG, JPG, JPEG, GIF (Max 5MB)
                                  </Typography>
                                </CardContent>
                              </Card>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                    )}

                    {this.state.isPortraitPhoneBannerImageUploaded === 1 && (
                      <Card
                        style={{
                          marginTop: 10,
                          position: "relative",
                          border: "1px solid #e0e0e0",
                          overflow: "hidden",
                        }}
                      >
                        <CardContent
                          style={{
                            paddingBottom: 16,
                            textAlign: "center",
                          }}
                        >
                          <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 15
                          }}>
                            <Typography
                              variant="subtitle2"
                              style={{ color: "#4caf50", fontWeight: 600 }}
                            >
                              ✓ Portrait Phone Banner Image
                            </Typography>
                            <div>
                              <Button
                                variant="outlined"
                                size="small"
                                style={{ marginRight: 8 }}
                                onClick={() => {
                                  this.setState({
                                    isPortraitPhoneBannerImageUploaded: 0,
                                    filesPortraitPhoneBanner: [],
                                    isFilePortraitPhoneBannerSelected: false,
                                  });
                                }}
                              >
                                Change
                              </Button>
                              <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={() => {
                                  this.setState({
                                    isPortraitPhoneBannerImageUploaded: 0,
                                    filesPortraitPhoneBanner: [],
                                    isFilePortraitPhoneBannerSelected: false,
                                  });
                                }}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>

                          {this.state.filesPortraitPhoneBanner.length > 0 ? (
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                                cursor: "pointer",
                                transition: "transform 0.2s ease",
                              }}
                              onClick={() => {
                                const file = this.state.filesPortraitPhoneBanner[0];
                                const imageUrl = file.url || (file instanceof File ? URL.createObjectURL(file) : "");
                                if (imageUrl) {
                                  window.open(imageUrl, '_blank');
                                }
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.02)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            >
                              <img
                                src={this.state.filesPortraitPhoneBanner[0].url || (this.state.filesPortraitPhoneBanner[0] instanceof File ? URL.createObjectURL(this.state.filesPortraitPhoneBanner[0]) : "")}
                                alt="Main Card"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "400px",
                                  width: "auto",
                                  height: "auto",
                                  border: "2px solid #e0e0e0",
                                  borderRadius: "8px",
                                  objectFit: "contain",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                  display: "block",
                                  margin: "0 auto",
                                  transition: "box-shadow 0.2s ease",
                                }}
                                onError={(e) => {
                                  console.error("Image failed to load");
                                  e.target.style.display = "none";
                                  e.target.parentNode.nextSibling.style.display = "flex";
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                                }}
                              />
                            </div>
                          ) : (
                            <div>No image available</div>
                          )}

                          <div
                            style={{
                              display: "none",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 40,
                              backgroundColor: "#f5f5f5",
                              borderRadius: "8px",
                              border: "2px dashed #ccc",
                              minHeight: "200px"
                            }}
                          >
                            <div style={{ fontSize: "48px", marginBottom: 15 }}>❌</div>
                            <Typography variant="h6" style={{ color: "#666", marginBottom: 10 }}>
                              Failed to load image
                            </Typography>
                          </div>
                        </CardContent>
                      </Card>
                    )}
                    {this.state.filesPortraitPhoneBannerError && (
                      <Typography
                        variant="caption"
                        style={{ color: "#f44336", marginTop: 5, display: "block" }}
                      >
                        {this.state.filesPortraitPhoneBannerError}
                      </Typography>
                    )}
                  </div>

                  {/* Tablet Banner Image Section */}
                  <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <Typography variant="subtitle2" style={{ marginBottom: 10, fontWeight: 600 }}>
                      Tablet Banner Image*
                    </Typography>

                    {this.state.isTabletBannerImageUploaded === 0 && (
                      <Dropzone
                        accept={"image/png, image/jpeg, image/jpg, image/gif"}
                        onDrop={this.onDropTabletBanner}
                        multiple={false}
                        maxSize={5242880}
                      >
                        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                          <section>
                            <div
                              style={{ textAlign: "center" }}
                              {...getRootProps({
                                className: "dropzone",
                                onChange: (event) =>
                                  this.handleChange({
                                    target: {
                                      name: "filesTabletBanner",
                                      value: event.target.files || [],
                                    },
                                  }),
                              })}
                            >
                              <Card
                                style={{
                                  backgroundColor: isDragActive
                                    ? "#e3f2fd"
                                    : isDragReject
                                      ? "#ffebee"
                                      : "#f5f5f5",
                                  marginTop: 10,
                                  border: isDragActive
                                    ? "2px dashed #2196f3"
                                    : isDragReject
                                      ? "2px dashed #f44336"
                                      : "2px dashed #ccc",
                                  transition: "all 0.3s ease",
                                  cursor: "pointer",
                                }}
                              >
                                <CardContent
                                  style={{
                                    paddingBottom: 18,
                                    padding: 30,
                                  }}
                                >
                                  <input name="filesTabletBanner" {...getInputProps()} />
                                  <div style={{ marginBottom: 10 }}>
                                    <i
                                      className="fas fa-cloud-upload-alt"
                                      style={{ fontSize: 48, color: "#999" }}
                                    />
                                  </div>
                                  <Typography
                                    style={{ cursor: "pointer" }}
                                    variant="subtitle1"
                                    color={this.state.filesTabletBanner.length > 0 ? "primary" : "textSecondary"}
                                  >
                                    {this.state.filesTabletBanner.length > 0
                                      ? `Selected: ${this.state.filesTabletBanner[0].name || this.state.filesTabletBanner[0].path}`
                                      : isDragActive
                                        ? "Drop the image here..."
                                        : "Click to select an image or drag and drop"}
                                  </Typography>
                                  <Typography variant="caption" display="block" style={{ marginTop: 5 }}>
                                    Supported formats: PNG, JPG, JPEG, GIF (Max 5MB)
                                  </Typography>
                                </CardContent>
                              </Card>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                    )}

                    {this.state.isTabletBannerImageUploaded === 1 && (
                      <Card
                        style={{
                          marginTop: 10,
                          position: "relative",
                          border: "1px solid #e0e0e0",
                          overflow: "hidden",
                        }}
                      >
                        <CardContent
                          style={{
                            paddingBottom: 16,
                            textAlign: "center",
                          }}
                        >
                          <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 15
                          }}>
                            <Typography
                              variant="subtitle2"
                              style={{ color: "#4caf50", fontWeight: 600 }}
                            >
                              ✓ Tablet Banner Image
                            </Typography>
                            <div>
                              <Button
                                variant="outlined"
                                size="small"
                                style={{ marginRight: 8 }}
                                onClick={() => {
                                  this.setState({
                                    isTabletBannerImageUploaded: 0,
                                    filesTabletBanner: [],
                                    isFileTabletBannerSelected: false,
                                  });
                                }}
                              >
                                Change
                              </Button>
                              <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={() => {
                                  this.setState({
                                    isTabletBannerImageUploaded: 0,
                                    filesTabletBanner: [],
                                    isFileTabletBannerSelected: false,
                                  });
                                }}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>

                          {this.state.filesTabletBanner.length > 0 ? (
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                                cursor: "pointer",
                                transition: "transform 0.2s ease",
                              }}
                              onClick={() => {
                                const file = this.state.filesTabletBanner[0];
                                const imageUrl = file.url || (file instanceof File ? URL.createObjectURL(file) : "");
                                if (imageUrl) {
                                  window.open(imageUrl, '_blank');
                                }
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.02)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            >
                              <img
                                src={this.state.filesTabletBanner[0].url || (this.state.filesTabletBanner[0] instanceof File ? URL.createObjectURL(this.state.filesTabletBanner[0]) : "")}
                                alt="Main Card Background"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "400px",
                                  width: "auto",
                                  height: "auto",
                                  border: "2px solid #e0e0e0",
                                  borderRadius: "8px",
                                  objectFit: "contain",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                  display: "block",
                                  margin: "0 auto",
                                  transition: "box-shadow 0.2s ease",
                                }}
                                onError={(e) => {
                                  console.error("Image failed to load");
                                  e.target.style.display = "none";
                                  e.target.parentNode.nextSibling.style.display = "flex";
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                                }}
                              />
                            </div>
                          ) : (
                            <div>No image available</div>
                          )}

                          <div
                            style={{
                              display: "none",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 40,
                              backgroundColor: "#f5f5f5",
                              borderRadius: "8px",
                              border: "2px dashed #ccc",
                              minHeight: "200px"
                            }}
                          >
                            <div style={{ fontSize: "48px", marginBottom: 15 }}>❌</div>
                            <Typography variant="h6" style={{ color: "#666", marginBottom: 10 }}>
                              Failed to load image
                            </Typography>
                          </div>
                        </CardContent>
                      </Card>
                    )}
                    {this.state.filesTabletBannerError && (
                      <Typography
                        variant="caption"
                        style={{ color: "#f44336", marginTop: 5, display: "block" }}
                      >
                        {this.state.filesTabletBannerError}
                      </Typography>
                    )}
                  </div>
                </>
                :
                <>
                  {/* Main Card Image Section */}
                  <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <Typography variant="subtitle2" style={{ marginBottom: 10, fontWeight: 600 }}>
                      Main Card Image
                    </Typography>

                    {this.state.isMainImageUploaded === 0 && (
                      <Dropzone
                        accept={"image/png, image/jpeg, image/jpg, image/gif"}
                        onDrop={this.onDrop}
                        multiple={false}
                        maxSize={5242880} // 5MB limit
                      >
                        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                          <section>
                            <div
                              style={{ textAlign: "center" }}
                              {...getRootProps({
                                className: "dropzone",
                                onChange: (event) =>
                                  this.handleChange({
                                    target: {
                                      name: "files",
                                      value: event.target.files || [],
                                    },
                                  }),
                              })}
                            >
                              <Card
                                style={{
                                  backgroundColor: isDragActive
                                    ? "#e3f2fd"
                                    : isDragReject
                                      ? "#ffebee"
                                      : "#f5f5f5",
                                  marginTop: 10,
                                  border: isDragActive
                                    ? "2px dashed #2196f3"
                                    : isDragReject
                                      ? "2px dashed #f44336"
                                      : "2px dashed #ccc",
                                  transition: "all 0.3s ease",
                                  cursor: "pointer",
                                }}
                              >
                                <CardContent
                                  style={{
                                    paddingBottom: 18,
                                    padding: 30,
                                  }}
                                >
                                  <input name="file" {...getInputProps()} />
                                  <div style={{ marginBottom: 10 }}>
                                    <i
                                      className="fas fa-cloud-upload-alt"
                                      style={{ fontSize: 48, color: "#999" }}
                                    />
                                  </div>
                                  <Typography
                                    style={{ cursor: "pointer" }}
                                    variant="subtitle1"
                                    color={this.state.files.length > 0 ? "primary" : "textSecondary"}
                                  >
                                    {this.state.files.length > 0
                                      ? `Selected: ${this.state.files[0].name || this.state.files[0].path}`
                                      : isDragActive
                                        ? "Drop the image here..."
                                        : "Click to select an image or drag and drop"}
                                  </Typography>
                                  <Typography variant="caption" display="block" style={{ marginTop: 5 }}>
                                    Supported formats: PNG, JPG, JPEG, GIF (Max 5MB)
                                  </Typography>
                                </CardContent>
                              </Card>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                    )}

                    {this.state.isMainImageUploaded === 1 && (
                      <Card
                        style={{
                          marginTop: 10,
                          position: "relative",
                          border: "1px solid #e0e0e0",
                          overflow: "hidden",
                        }}
                      >
                        <CardContent
                          style={{
                            paddingBottom: 16,
                            textAlign: "center",
                          }}
                        >
                          <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 15
                          }}>
                            <Typography
                              variant="subtitle2"
                              style={{ color: "#4caf50", fontWeight: 600 }}
                            >
                              ✓ Main Card Image
                            </Typography>
                            <div>
                              <Button
                                variant="outlined"
                                size="small"
                                style={{ marginRight: 8 }}
                                onClick={() => {
                                  this.setState({
                                    isMainImageUploaded: 0,
                                    files: [],
                                    isFileSelected: false,
                                  });
                                }}
                              >
                                Change
                              </Button>
                              <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={() => {
                                  this.setState({
                                    isMainImageUploaded: 0,
                                    files: [],
                                    isFileSelected: false,
                                  });
                                }}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>

                          {this.state.files.length > 0 ? (
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                                cursor: "pointer",
                                transition: "transform 0.2s ease",
                              }}
                              onClick={() => {
                                const file = this.state.files[0];
                                const imageUrl = file.url || (file instanceof File ? URL.createObjectURL(file) : "");
                                if (imageUrl) {
                                  window.open(imageUrl, '_blank');
                                }
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.02)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            >
                              <img
                                src={this.state.files[0].url || (this.state.files[0] instanceof File ? URL.createObjectURL(this.state.files[0]) : "")}
                                alt="Main Card"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "400px",
                                  width: "auto",
                                  height: "auto",
                                  border: "2px solid #e0e0e0",
                                  borderRadius: "8px",
                                  objectFit: "contain",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                  display: "block",
                                  margin: "0 auto",
                                  transition: "box-shadow 0.2s ease",
                                }}
                                onError={(e) => {
                                  console.error("Image failed to load");
                                  e.target.style.display = "none";
                                  e.target.parentNode.nextSibling.style.display = "flex";
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                                }}
                              />
                            </div>
                          ) : (
                            <div>No image available</div>
                          )}

                          <div
                            style={{
                              display: "none",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 40,
                              backgroundColor: "#f5f5f5",
                              borderRadius: "8px",
                              border: "2px dashed #ccc",
                              minHeight: "200px"
                            }}
                          >
                            <div style={{ fontSize: "48px", marginBottom: 15 }}>❌</div>
                            <Typography variant="h6" style={{ color: "#666", marginBottom: 10 }}>
                              Failed to load image
                            </Typography>
                          </div>
                        </CardContent>
                      </Card>
                    )}
                    {this.state.filesError && (
                      <Typography
                        variant="caption"
                        style={{ color: "#f44336", marginTop: 5, display: "block" }}
                      >
                        {this.state.filesError}
                      </Typography>
                    )}
                  </div>

                  {/* Main Card Image Background Section */}
                  <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <Typography variant="subtitle2" style={{ marginBottom: 10, fontWeight: 600 }}>
                      Main Card Image Background
                    </Typography>

                    {this.state.isBackgroundImageUploaded === 0 && (
                      <Dropzone
                        accept={"image/png, image/jpeg, image/jpg, image/gif"}
                        onDrop={this.onDropBackground}
                        multiple={false}
                        maxSize={5242880}
                      >
                        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                          <section>
                            <div
                              style={{ textAlign: "center" }}
                              {...getRootProps({
                                className: "dropzone",
                                onChange: (event) =>
                                  this.handleChange({
                                    target: {
                                      name: "filesBackground",
                                      value: event.target.files || [],
                                    },
                                  }),
                              })}
                            >
                              <Card
                                style={{
                                  backgroundColor: isDragActive
                                    ? "#e3f2fd"
                                    : isDragReject
                                      ? "#ffebee"
                                      : "#f5f5f5",
                                  marginTop: 10,
                                  border: isDragActive
                                    ? "2px dashed #2196f3"
                                    : isDragReject
                                      ? "2px dashed #f44336"
                                      : "2px dashed #ccc",
                                  transition: "all 0.3s ease",
                                  cursor: "pointer",
                                }}
                              >
                                <CardContent
                                  style={{
                                    paddingBottom: 18,
                                    padding: 30,
                                  }}
                                >
                                  <input name="fileBackground" {...getInputProps()} />
                                  <div style={{ marginBottom: 10 }}>
                                    <i
                                      className="fas fa-cloud-upload-alt"
                                      style={{ fontSize: 48, color: "#999" }}
                                    />
                                  </div>
                                  <Typography
                                    style={{ cursor: "pointer" }}
                                    variant="subtitle1"
                                    color={this.state.filesBackground.length > 0 ? "primary" : "textSecondary"}
                                  >
                                    {this.state.filesBackground.length > 0
                                      ? `Selected: ${this.state.filesBackground[0].name || this.state.filesBackground[0].path}`
                                      : isDragActive
                                        ? "Drop the image here..."
                                        : "Click to select an image or drag and drop"}
                                  </Typography>
                                  <Typography variant="caption" display="block" style={{ marginTop: 5 }}>
                                    Supported formats: PNG, JPG, JPEG, GIF (Max 5MB)
                                  </Typography>
                                </CardContent>
                              </Card>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                    )}

                    {this.state.isBackgroundImageUploaded === 1 && (
                      <Card
                        style={{
                          marginTop: 10,
                          position: "relative",
                          border: "1px solid #e0e0e0",
                          overflow: "hidden",
                        }}
                      >
                        <CardContent
                          style={{
                            paddingBottom: 16,
                            textAlign: "center",
                          }}
                        >
                          <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 15
                          }}>
                            <Typography
                              variant="subtitle2"
                              style={{ color: "#4caf50", fontWeight: 600 }}
                            >
                              ✓ Main Card Image Background
                            </Typography>
                            <div>
                              <Button
                                variant="outlined"
                                size="small"
                                style={{ marginRight: 8 }}
                                onClick={() => {
                                  this.setState({
                                    isBackgroundImageUploaded: 0,
                                    filesBackground: [],
                                    isFileBackgroundSelected: false,
                                  });
                                }}
                              >
                                Change
                              </Button>
                              <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={() => {
                                  this.setState({
                                    isBackgroundImageUploaded: 0,
                                    filesBackground: [],
                                    isFileBackgroundSelected: false,
                                  });
                                }}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>

                          {this.state.filesTabletBanner.length > 0 ? (
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                                cursor: "pointer",
                                transition: "transform 0.2s ease",
                              }}
                              onClick={() => {
                                const file = this.state.filesBackground[0];
                                const imageUrl = file.url || (file instanceof File ? URL.createObjectURL(file) : "");
                                if (imageUrl) {
                                  window.open(imageUrl, '_blank');
                                }
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.02)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                              }}
                            >
                              <img
                                src={this.state.filesBackground[0].url || (this.state.filesBackground[0] instanceof File ? URL.createObjectURL(this.state.filesBackground[0]) : "")}
                                alt="Main Card Background"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "400px",
                                  width: "auto",
                                  height: "auto",
                                  border: "2px solid #e0e0e0",
                                  borderRadius: "8px",
                                  objectFit: "contain",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                  display: "block",
                                  margin: "0 auto",
                                  transition: "box-shadow 0.2s ease",
                                }}
                                onError={(e) => {
                                  console.error("Image failed to load");
                                  e.target.style.display = "none";
                                  e.target.parentNode.nextSibling.style.display = "flex";
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                                }}
                              />
                            </div>
                          ) : (
                            <div>No image available</div>
                          )}

                          <div
                            style={{
                              display: "none",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 40,
                              backgroundColor: "#f5f5f5",
                              borderRadius: "8px",
                              border: "2px dashed #ccc",
                              minHeight: "200px"
                            }}
                          >
                            <div style={{ fontSize: "48px", marginBottom: 15 }}>❌</div>
                            <Typography variant="h6" style={{ color: "#666", marginBottom: 10 }}>
                              Failed to load image
                            </Typography>
                          </div>
                        </CardContent>
                      </Card>
                    )}
                    {this.state.filesBackgroundError && (
                      <Typography
                        variant="caption"
                        style={{ color: "#f44336", marginTop: 5, display: "block" }}
                      >
                        {this.state.filesBackgroundError}
                      </Typography>
                    )}
                  </div>
                </>
              }


              <form noValidate onSubmit={this.submitVoucher}>
                <input id="F300FromSubmitButton" type="submit" hidden />
              </form>
            </div>
            {this.state.voucherType + "" != "2" ? (
              <>

                <FormLabel component="legend">Select discount for : </FormLabel>
                {/*Is Voucher Available For All User*/}
                {/*1-> For All Users*/}
                {/*2-> User Specific*/}
                <div style={{ width: "100%", marginBottom: 10 }}>
                  <RadioGroup
                    row
                    aria-label="voucher-available-for-all"
                    name="voucher-available-for-all"
                    defaultValue={"0"}
                    value={isVoucherAvailableForAllUsers + ""}
                    onChange={(e) => this.setVoucherAvailableForAll(e)}
                  >
                    <FormControlLabel
                      value="0"
                      control={<Radio style={{ color: "#3f51b5" }} />}
                      label="User Specific"
                      disabled={this.state.voucherType + "" == "1" ? true : false}
                    />
                    <FormControlLabel
                      value="1"
                      control={<Radio style={{ color: "#3f51b5" }} />}
                      label="All Users"
                    />
                  </RadioGroup>
                </div>

                <div style={{ width: "100%" }}>
                  {isVoucherAvailableForAllUsers == "0" ? (
                    <Grid
                      container
                      item
                      xs={6}
                      style={{
                        position: "relative",
                        zIndex: 10,
                      }}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="subtitle2"
                          align="left"
                          color="textSecondary"
                          style={{ paddingBottom: 5 }}
                        >
                          Select Users
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ paddingBottom: 20 }}>
                        <Select
                          // defaultValue={}
                          // isMulti
                          value={this.state.selectedUsersList}
                          name="usersList"
                          options={usersList}
                          onChange={(e) => {
                            this.setUsers(e);
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={{
                            option: (base) => ({
                              ...base,
                              background: "#FFFFFF",
                              backgroundColor: "#FFFFFF",
                            }),
                          }}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <span />
                  )}
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "20px",
                  }}
                >
                  <TextField
                    id="voucher-label"
                    label="Voucher Label"
                    variant="outlined"
                    value={this.state.voucherLabel}
                    onChange={(val) => {
                      // eslint-disable-next-line react/no-direct-mutation-state
                      this.state.voucherLabel = val.target.value;
                      this.validateVoucherForm();
                    }}
                    style={{ width: "49.5%" }}
                  />
                  <div style={{ width: "1%" }} />
                  <TextField
                    id="voucher-description"
                    label="Voucher Description"
                    variant="outlined"
                    value={this.state.voucherDescription}
                    inputProps={{
                      maxLength: 250,
                    }}
                    style={{ width: "49.5%" }}
                    onChange={(val) => {
                      // eslint-disable-next-line react/no-direct-mutation-state
                      this.state.voucherDescription = val.target.value;
                      this.validateVoucherForm();
                    }}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 20,
                  }}
                >
                  <TextField
                    id="voucher-code"
                    label="Voucher Code"
                    variant="outlined"
                    inputProps={{ "aria-readonly": true }}
                    style={{ width: "49.5%", marginRight: "1%" }}
                    value={voucherCode}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.getGeneratedVoucherCodeFromServer();
                    }}
                  >
                    Generate Voucher Code
                  </Button>
                </div>

                {/*Voucher Amount Type*/}
                {/*1-> Percentage*/}
                {/*2-> Amount*/}
                <RadioGroup
                  row
                  aria-label="voucher-type"
                  name="voucher-type"
                  defaultValue={"1"}
                  value={voucherAmountType + ""}
                  onChange={(e) => this.setVoucherAmountType(e)}
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio style={{ color: "#3f51b5" }} />}
                    label="Percentage"
                  />
                  <FormControlLabel
                    disabled={this.state.voucherType + "" == "1" ? true : false}
                    value="0"
                    control={<Radio style={{ color: "#3f51b5" }} />}
                    label="Amount"
                  />
                </RadioGroup>

                <div style={{ width: "100%", marginBottom: 20 }}>
                  {voucherAmountType === "1" ? (
                    <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                      <OutlinedInput
                        id="outlined-adornment-weight"
                        type={"tel"}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={this.state.voucherPercentage}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          "aria-label": "weight",
                        }}
                        onChange={(val) => {
                          // eslint-disable-next-line react/no-direct-mutation-state
                          this.state.voucherPercentage = val.target.value;
                          this.validateVoucherForm();
                        }}
                      />
                      <FormHelperText id="outlined-weight-helper-text">
                        Voucher Amount Type
                      </FormHelperText>
                    </FormControl>
                  ) : (
                    <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                      <OutlinedInput
                        disabled={this.state.voucherType + "" == "1" ? true : false}
                        id="outlined-adornment-weight"
                        type={"tel"}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={this.state.voucherAmount}
                        endAdornment={
                          <InputAdornment position="end">Rs</InputAdornment>
                        }
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          "aria-label": "weight",
                        }}
                        onChange={(val) => {
                          // eslint-disable-next-line react/no-direct-mutation-state
                          this.state.voucherAmount = val.target.value;
                          this.validateVoucherForm();
                        }}
                      />
                      <FormHelperText id="outlined-weight-helper-text">
                        Voucher Amount Type
                      </FormHelperText>
                    </FormControl>
                  )}
                </div>

                {/* <div style={{ width: "100%" }}>
                {selectedVoucherCategoriesList.length === 0 ? (
                  <span />
                  ) : (
                
                    <span style={{}}>
                    <>
                  
                </span>
                </>      
              </div> */}

                <div style={{ width: "100%" }}>
                  {selectedVoucherCategoriesList.length !== 0 ? (
                    <span />
                  ) : (
                    <>
                      <span style={{}}>
                        {
                          <FormControl component="fieldset">
                            <FormLabel component="legend">
                              Tick mark the checkbox for store wide selection{" "}
                            </FormLabel>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={
                                      this.state.voucherType + "" == "1"
                                        ? true
                                        : false
                                    }
                                    checked={selectStoreWideCategories}
                                    onChange={(e) =>
                                      this.updateStoreWideCategoriesSelection(e)
                                    }
                                    name="select-store-wide-categories"
                                    style={{ color: "#3f51b5" }}
                                  />
                                }
                                label="Store Wide"
                              />
                            </FormGroup>
                          </FormControl>
                        }
                      </span>
                    </>
                  )}
                </div>

                <Grid container spacing={2} alignItems={"flex-start"}>
                  <Grid
                    container
                    item
                    xs={6}
                    style={{
                      position: "relative",
                      zIndex: 10,
                    }}
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"
                        align="left"
                        color="textSecondary"
                        style={{ paddingBottom: 5 }}
                      >
                        Select your voucher categories
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ paddingBottom: 20 }}>
                      <Select
                        // defaultValue={}
                        value={selectedVoucherCategoriesList}
                        isMulti={this.state.voucherType == "0"}
                        name="voucherCategoriesList"
                        options={voucherCategoriesList}
                        onChange={(e) => {
                          this.setVoucherCategoryV2(e);
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (base) => ({
                            ...base,
                            background: "#FFFFFF",
                            backgroundColor: "#FFFFFF",
                          }),
                        }}
                        isDisabled={selectStoreWideCategories}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    item
                    xs={6}
                    style={{
                      position: "relative",
                      zIndex: 10,
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      {selectedVoucherCategoriesList.length === 0 ? (
                        <span />
                      ) : (
                        <>
                          <span style={{}}>
                            {
                              <FormControl component="fieldset">
                                <FormLabel component="legend">
                                  Tick mark the checkbox to select all products in
                                  the category
                                </FormLabel>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={selectAllCategoryProducts}
                                        onChange={(e) =>
                                          this.updateAllCategoryProductsSelection(e)
                                        }
                                        name="select-all-category-products"
                                        style={{ color: "#3f51b5" }}
                                      />
                                    }
                                    label="Select All Products"
                                  />
                                </FormGroup>
                              </FormControl>
                            }
                          </span>
                        </>
                      )}
                    </div>
                  </Grid>

                  {voucherCategoryProductList.length > 0 ? (
                    <Grid
                      item
                      xs={6}
                      style={{
                        position: "relative",
                        zIndex: 10,
                      }}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="subtitle2"
                          align="left"
                          color="textSecondary"
                          style={{ paddingBottom: 5 }}
                        >
                          Select your voucher products
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ paddingBottom: 20 }}>
                        <Select
                          isMulti
                          value={selectedVoucherCategoriesProductList}
                          name="voucherCategoriesProductList"
                          options={voucherCategoryProductList}
                          onChange={(e) => {
                            this.setVoucherCategoryProductV2(e);
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isDisabled={selectAllCategoryProducts}
                          styles={{
                            option: (base) => ({
                              ...base,
                              background: "#FFFFFF",
                              backgroundColor: "#FFFFFF",
                            }),
                          }}
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <span />
                  )}
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                >
                  <Grid item xs={6}>
                    <TextField
                      id="min-applicable-amount"
                      label="Min Applicable Amount"
                      variant="outlined"
                      value={this.state.minimumVoucherApplicableAmount}
                      type={"tel"}
                      fullWidth
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(val) => {
                        // eslint-disable-next-line react/no-direct-mutation-state
                        this.state.minimumVoucherApplicableAmount =
                          val.target.value;
                        this.validateVoucherForm();
                      }}
                      isDisabled={isVoucherAvailableForAllUsers == "0"}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="voucher-usage-limit"
                      label="Voucher Usage Limit"
                      variant="outlined"
                      value={this.state.voucherUsageLimit}
                      //    style={{width: "245px"}}
                      fullWidth
                      type={"tel"}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(val) => {
                        // eslint-disable-next-line react/no-direct-mutation-state
                        this.state.voucherUsageLimit = val.target.value;
                        this.validateVoucherForm();
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <span>
                      <DatePicker
                        format="dd-MM-yyyy"
                        autoOk
                        label="Effective from"
                        id="effectiveVoucherFrom"
                        value={this.state.effectiveVoucherFrom}
                        onChange={this.setEffectiveFrom}
                        required
                        fullWidth
                        inputVariant="outlined"
                      />
                    </span>
                  </Grid>
                  <Grid item xs={6}>
                    <span>
                      <DatePicker
                        format="dd-MM-yyyy"
                        autoOk
                        label="Effective To"
                        id="effectiveVoucherTo"
                        value={this.state.effectiveVoucherTo}
                        onChange={this.setEffectiveTo}
                        required
                        fullWidth
                        inputVariant="outlined"
                      />
                    </span>
                  </Grid>
                </Grid>
              </>)
              : (<>

                <div style={{ width: "100%" }}>

                  <Grid
                    container
                    item
                    xs={6}
                    style={{
                      position: "relative",
                      zIndex: 10,
                    }}
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"
                        align="left"
                        color="textSecondary"
                        style={{ paddingBottom: 5 }}
                      >
                        Select General Pricing Discount
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ paddingBottom: 20 }}>
                      <Select
                        // defaultValue={}
                        // isMulti
                        value={this.state.selectedGeneralPricingDiscountList}
                        name="generalPricingDiscountList"
                        options={generalPricingDiscountList}
                        onChange={(e) => {
                          this.setGeneralPricingDiscount(e);
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (base) => ({
                            ...base,
                            background: "#FFFFFF",
                            backgroundColor: "#FFFFFF",
                          }),
                        }}
                      />
                    </Grid>
                  </Grid>

                </div>
              </>)

            }


            <>




              <div style={{ width: "100%" }}>

                <>
                  <span style={{}}>
                    {
                      <FormControl component="fieldset">
                        <FormLabel component="legend">
                          Tick mark the checkbox To Allow notification{" "}
                        </FormLabel>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox

                                checked={isNotificationNeededToSent}
                                onChange={(e) =>
                                  this.setState({
                                    isNotificationNeededToSent: e.target.checked,
                                  })
                                }
                                name="send-notification"
                                style={{ color: "#3f51b5" }}
                              />
                            }
                            label="Send Notification"
                          />
                        </FormGroup>
                      </FormControl>
                    }
                  </span>
                </>
              </div>


            </>


            {isNotificationNeededToSent && (
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
                spacing={2}
              >
                <Grid item xs={12}>
                  <TextField
                    id="outlined-multiline-static"
                    label="Notification"
                    value={this.state.notification}
                    multiline
                    rows={4}
                    placeholder="Enter message to send as notification"
                    variant="outlined"
                    fullWidth
                    inputProps={{
                      maxLength: 250,
                    }}
                    onChange={(val) => {
                      // eslint-disable-next-line react/no-direct-mutation-state
                      this.state.notification = val.target.value;
                      this.validateVoucherForm();
                    }}
                  />
                </Grid>

              </Grid>
            )

            }

          </Card>
          <BottomBar
            //rightButtonDisable={this.state.recordId == 0}
            leftButtonAction={() => this.viewReport()}
            leftButtonText="View"
            rightButtonText="Submit"
            rightButtonAction={() => this.onClickSubmit()}
          />
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
            autoHideDuration={3000}
          />
        </Grid>
      </Fragment >
    );
  }
}

F300DiscountVoucherForm.propTypes = {
  match: PropTypes.object,
};

F300DiscountVoucherForm.defaultProps = {
  match: {
    params: {},
  },
};

export default F300DiscountVoucherForm;
